import { useState } from 'react';
import { Download, FileSpreadsheet } from 'lucide-react';

import { downloadUrl } from '@/api/client';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

function firstOfMonth(): string {
  const date = new Date();
  date.setDate(1);
  return date.toISOString().split('T')[0]!;
}

function today(): string {
  return new Date().toISOString().split('T')[0]!;
}

/**
 * GST summary export — grouped by rate slab (CGST + SGST), ready for GSTR-1
 * reconciliation. Unlike the other reports this has no on-screen chart: it's
 * a filing document, and the number that matters is the one in the download.
 */
export function GstSummaryTab() {
  const [from, setFrom] = useState(firstOfMonth());
  const [to, setTo] = useState(today());

  const range = { from, to };
  const disabled = !from || !to;

  return (
    <div className="space-y-4">
      <Card>
        <CardContent className="space-y-4 py-6">
          <div className="flex items-center gap-3">
            <FileSpreadsheet className="h-8 w-8 shrink-0 text-primary" />
            <div>
              <p className="font-medium">GST summary</p>
              <p className="text-xs text-muted-foreground">
                Taxable value, CGST, and SGST by rate slab — for GSTR-1 reconciliation.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:max-w-sm">
            <div className="space-y-1.5">
              <Label htmlFor="gst-from">From</Label>
              <Input id="gst-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="gst-to">To</Label>
              <Input id="gst-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} />
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            <Button asChild disabled={disabled}>
              <a href={downloadUrl('/api/export/gst', range)}>
                <Download /> Download XLSX
              </a>
            </Button>
            <Button variant="outline" asChild disabled={disabled}>
              <a href={downloadUrl('/api/export/gst/csv', range)}>
                <Download /> Download CSV
              </a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}